/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Typography, Grid } from '@mui/material';
import { CallBox, CallButton, CallHeader, CallStateActive } from './call-styles';
import { Phone } from '@mui/icons-material';
import { useLwp } from '../../hooks/use-lwp';
import { formatUSPhoneNumber } from '../../utils/formatter';

export default function CallOutbound(props: {}) {
  const {
    phoneState: { contactName, phoneNumber },
    rejectCall
  } = useLwp();

  return (
    <CallBox data-testid="call-outbound">
      <CallHeader>
        <Grid container>
          <Grid item xs={10} zeroMinWidth>
            <CallStateActive>OUTBOUND CALL</CallStateActive>
            <Typography variant="h6" noWrap>
              {contactName ? contactName : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(phoneNumber)}</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'right' }}>
            <CallButton
              onClick={rejectCall}
              sx={{ backgroundColor: 'rgb(244, 73, 72)', '&:hover': { backgroundColor: 'rgb(244, 73, 72)' } }}
            >
              <Phone
                sx={{
                  transform: 'rotate(135deg)'
                }}
              />
            </CallButton>
          </Grid>
        </Grid>
      </CallHeader>
    </CallBox>
  );
}
